import { z } from 'zod';
import { OrderStatus, FulfillmentStatus, PaymentStatus } from '../enums.js';

export const orderListQuerySchema = z.object({
  status: z.nativeEnum(OrderStatus).optional(),
  paymentStatus: z.nativeEnum(PaymentStatus).optional(),
  fulfillmentStatus: z.nativeEnum(FulfillmentStatus).optional(),
  q: z.string().max(120).optional(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});

export const fulfillOrderSchema = z.object({
  carrier: z.string().min(1).max(80),
  service: z.string().max(80).optional(),
  trackingNumber: z.string().max(120).optional(),
  labelUrl: z.string().url().optional(),
  packageWeightGrams: z.number().min(0).max(200_000).optional(),
  items: z
    .array(z.object({ orderItemId: z.string().uuid(), quantity: z.number().int().min(1) }))
    .min(1),
  notifyCustomer: z.boolean().default(true),
});

export const updateOrderStatusSchema = z.object({
  status: z.nativeEnum(OrderStatus),
  note: z.string().max(1000).optional(),
});

export const refundOrderSchema = z.object({
  amount: z.number().int().min(1),
  reason: z.string().min(3).max(1000),
  restock: z.boolean().default(true),
});

export type FulfillOrderInput = z.infer<typeof fulfillOrderSchema>;
